import {useSnackbar, VariantType} from 'notistack'

export const useNotification = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const sendNotification = (text: string, variant: VariantType = 'default') => {
    enqueueSnackbar(text, { variant, autoHideDuration: 1000 })
  }

  const sendSuccessNotification = (text: string) => {
    enqueueSnackbar(text, { variant: 'success' , autoHideDuration: 1000})
  }

  const sendErrorNotification = (text: string) => {
    enqueueSnackbar(text, { variant: 'error', hideIconVariant: true , autoHideDuration: 1000})
  }

  return {
    sendNotification,
    sendSuccessNotification,
    sendErrorNotification,
    enqueueSnackbar,
    closeSnackbar
  }
}
